import React, { useCallback, useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material'
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom'
import InputTextMask from '../../../../components/input/inputTextMask'
import { produce } from 'immer'
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom'
import TableRowCommon from '../../../../components/table/TableRowCommon'
import TableCustom from '../../../../components/table/tableCustom'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { BookingMeetingRoomApproveApi, ContractEmployee, FileCondition, MeetingRoomCondition } from '../../../../api/booking-meeting-room-approve/booking-meeting-room-approve.api'
import ModalCustom from '../../../../components/modal/modalCustomCms'
import StateComponents from '../../../../components/state-component/StateComponents'
import { EmployeeApi, list_employee_booking_meeting_room } from '../../../../api/employee/employee.api'
import { ProfileCard } from '../../organization/element/element'
import UploadFile from '../../../../components/upload/UploadFile'
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store/store'
import { ImageContent } from '../../../../assets/background/background'
import { debouncedApiCall } from '../../../../utils/app.utils'
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal'
import { useNavigate } from 'react-router-dom'
import { routeName } from '../../../../routes/routeName'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import { BookingMeetingRoomFront, cancel_booking_type_data } from '../../../../api/booking-meeting-room-front/booking_meeting_room_front.api'
import { useTranslation } from 'react-i18next'

type Props = {
    id_meeting_room: number;
    uploadMultiFilePromise: (file: File[]) => Promise<any[]>;
    handleDownloadFile: (id_meeting_room_file: number, file_name: string) => void;
    view?: boolean;
    show_cancel_booking?: boolean;
}

type CancelRejectItem = {
    checked: boolean, label: string, day: string
}

const MeetingRoomContact: React.FC<Props> = ({ show_cancel_booking, id_meeting_room, uploadMultiFilePromise, handleDownloadFile, view }: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const base_url_image = useSelector((state: RootState) => state.api.image_api);
    const navigate = useNavigate();
    const dispatch = useDispatch();



    const [show_modal, set_show_modal] = useState<boolean>(false);
    const [contact_employee, set_contact_employee] = useState<ContractEmployee[]>([]);
    const [is_update, set_is_update] = useState<boolean>(false);
    const [employee_detail, set_employee_detail] = useState<ContractEmployee | null>(null);
    const [files, set_files] = useState<{ file: any }[]>([
        {
            file: null
        }
    ]);

    const [cancel_reject_data, set_cancel_reject_data] = useState<{ checked: boolean, label: string, day: string }[]>([
        {
            checked: false,
            day: "",
            label: "หลังเจ้าหน้าที่อนุมัติการจองภายใน" // i18n-ignore: display label, translated at render site with t(label)
        },
        {
            checked: false,
            day: "",
            label: "ก่อนถึงวันที่จอง" // i18n-ignore: display label, translated at render site with t(label)
        },
    ])
    const handleCloseModal = () => {
        set_show_modal(false);
        set_is_view(false);
        set_employee_detail(null);
        set_is_update(false);
    }
    const handleChange = <K extends keyof CancelRejectItem>(
        field: K,
        value: CancelRejectItem[K],
        index: number
    ) => {
        set_cancel_reject_data((prev) =>
            produce(prev, (draft) => {
                draft[index][field] = value;
            })
        );
    };


    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [employee_data, set_employee_data] = useState<any[]>([]);
    const [is_view, set_is_view] = useState<boolean>(false);
    const [search_employee, set_search_employyee] = useState<string>("");
    const [approve_data, set_approve_data] = useState<any>(null);
    const [booking_meeting_room_data, set_booking_meeting_room_data] = useState<any>(null);


    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const handleAddFile = () => {
        const new_file = {
            file: null
        }
        set_files((prev) => produce(prev, (draft) => {
            draft.push(new_file);
        }))
    }
    const handleChangeFile = (index: number, new_file: any) => {
        set_files(prev =>
            produce(prev, draft => {
                if (draft[index]) {
                    draft[index].file = new_file;
                }
            })
        );
    };
    const handleDeleteRow = (index: number) => {
        set_files((prev) => prev.filter((_, i) => i !== index))
    }
    const handleDeleteFile = (index: number) => {
        set_files((prev) => produce(prev, (draft) => {
            if (draft[index]) {
                draft[index].file = null
            }
        }))
    }
    const headCells = [
        {
            id: "subject_no", width: 60, sortable: false, disablePadding: false, align: 'center', label: t("ชื่อ - นามสกุล")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "left", label: t("ตำแหน่งงานปัจจุบัน")
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("เบอร์โทร")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("อีเมลองค์กร")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 50, class: matches && contact_employee.length > 0, label: (
                <div className='flex justify-end mr-4 items-center'>
                    {!view && (
                        <Button
                            disabled={view}
                            onClick={() => set_show_modal(true)}
                            startIcon={<AddCircleOutlineOutlinedIcon />} sx={{
                                color: "white", border: '1px solid white', '&:hover': {
                                    border: '1px solid white',
                                }
                            }} variant='outlined'>
                            {t("เพิ่ม")}
                        </Button>
                    )}
                </div>
            )
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {

            contact_last_name,
            contact_name,
            id_employee,
            email,
            position,
            tel,

        } = objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: `${contact_name || ""} ${contact_last_name || ""}` },
                {
                    option: "TEXT",
                    align: "left",
                    label: position || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: tel || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: email || '-'
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && contact_employee.length > 0,
                    component: <div className='flex justify-center gap-4 items-center'>
                        <OptionsButtonCustom
                            // enableEdit={!view}
                            enableView
                            enableDelete={!view}
                            onViewClick={() => {
                                set_show_modal(true);
                                set_employee_detail(objData);
                                set_is_view(true);
                            }}
                            // onEditClick={() => {
                            //     set_show_modal(true);
                            //     set_employee_detail(objData);
                            //     set_is_update(true);
                            // }}
                            onDeleteClick={() => {
                                handleDeleteEmployee(id_employee);
                            }}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };



    // FETCH
    const handleGetEmployeeData = useCallback(async () => {
        let query: list_employee_booking_meeting_room = {
            limit: 20
        };
        if (search_employee) query.keyword = search_employee
        await EmployeeApi.listActiveEmployee(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_employee_data(response);
            }
        })
    }, [search_employee])

    const handleUploadFile = async (files_value: { file: File | null }[]): Promise<FileCondition[]> => {
        if (files_value?.length > 0) {
            const file_data = files_value?.flatMap((list) => list?.file) as File[];
            const id_file = await uploadMultiFilePromise(file_data);
            if (id_file?.length > 0) {
                return id_file?.map((list) => {
                    const file = list?.file;
                    return {
                        file_name: file?.file_name,
                        file_path: file?.file_path,
                        file_size: file?.file_size,
                        file_type: file?.file_type,
                        id_meeting_room_file: file?.id_meeting_room_file
                    }
                })
            } else {
                return []
            }
        } else {
            return []
        }
    }

    const handleDeleteEmployee = (id_employee: number) => {
        set_contact_employee((prev) => prev?.filter((x) => x?.id_employee !== id_employee));
    }
    const handleAddEmployee = () => {
        const same_employee = contact_employee?.some((x) => x?.id_employee === employee_detail?.id_employee);
        if (same_employee && !is_update) {
            return alertError(t("มีผู้ดูแลห้องคนนี้อยู่แล้ว ไม่สามารถเพิ่มได้"))
        }
        if (is_update && same_employee) {
            // set_contact_employee((prev) => produce(prev, (draft) => {
            //     const find_emp = draft?.find((x) => x?.id_employee == employee_detail?.id_employee);
            //     // if(find_emp){
            //     //     find_emp.
            //     // }
            // }))
        } else {
            set_contact_employee((prev) => produce(prev, (draft) => {
                draft.push(employee_detail as any);
            }))
        }

        handleCloseModal();
        set_search_employyee("");
    }
    const generateBody = async (): Promise<MeetingRoomCondition> => {
        let file_data: FileCondition[] = [];
        if (files?.length > 0) {
            file_data = await handleUploadFile(files.filter((x) => !x?.file?.id_meeting_room_file));
        }
        if (files?.some((x) => x?.file?.id_meeting_room_file)) {
            const id_file_api: FileCondition[] = files?.filter((x) => x?.file?.id_meeting_room_file)?.map((list) => ({
                file_name: list?.file?.file_name,
                file_path: list?.file?.file_path,
                file_size: list?.file?.file_size,
                file_type: list?.file?.file_type,
                id_meeting_room_file: list?.file?.id_meeting_room_file
            }));
            file_data.push(...id_file_api);
        }
        return {
            id_meeting_room,
            after_approves: cancel_reject_data[0].checked,
            after_approves_day: cancel_reject_data[0].day ? Number(cancel_reject_data[0].day) : 0,
            before_booking: cancel_reject_data[1].checked,
            before_booking_day: cancel_reject_data[1].day ? Number(cancel_reject_data[0].day) : 0,
            file_conditions: file_data,
            contract_employees: contact_employee,
        }
    }

    // ใช้ทั้ง UPDATE และ CREATE ใน POST
    const handleSubmitForm = () => {
        alertActive(t("อนุมัติคำร้องขอจอง"), t("ท่านต้องการอนุมัติคำร้องขอจอง ใช่หรือไม่"), undefined, undefined, async () => {
            const body = await generateBody();
            dispatch(setLoading());
            await BookingMeetingRoomApproveApi.createCondition(body).then((res) => {
                if (res.status < 300) {
                    navigate(routeName.cms.BookingRoomRequestMangement);
                    alertSuccess(t("อนุมัติคำร้องขอจอง"), t("อนุมัติคำร้องขอจอง เรียบร้อยแล้ว"));
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    console.log(approve_data,'approve_dataapprove_data')
    const handleCancelBooking = () => {
        const body: cancel_booking_type_data = {
            after_approves_day: Number(cancel_reject_data[0]?.day || 0),
            before_booking_day: Number(cancel_reject_data[1]?.day || 0),
            id_meeting_room,
            meeting_room_approve_date: approve_data?.meeting_room_approve_date,
            meeting_room_start_date: booking_meeting_room_data?.meeting_room_start_date
        }
        alertActive(t("ยกเลิกการจอง"), t("ต้องการยกเลิกการจอง หรือไม่?"), undefined, undefined, async () => {
            await BookingMeetingRoomFront.cancelBooking(body).then((res) => {
                if (res.status < 300) {
                    navigate(routeName.public.classroom_meeting_booking)
                    alertSuccess(t("ยกเลิกการจอง"), t("ยกเลิกการจอง เรียบร้อย"))
                }
            }).catch((err) => {
                alertError(t("ยกเลิกการจอง ไม่สำเร็จ"), err?.response?.data?.message || "");
            })
        })
    }

    const handleGetDataDetail = async () => {
        dispatch(setLoading());
        await BookingMeetingRoomApproveApi.findOneCondition(id_meeting_room).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data;
                const approve_data_res = response?.approve_data;
                const contract_employees_res = response?.contract_employees || []
                const file_conditions: any[] = response?.file_conditions || [];
                const booking_meeting_room_res = response?.booking_meeting_room_data;
                if (booking_meeting_room_res) {
                    set_booking_meeting_room_data(booking_meeting_room_res);
                }
                if (approve_data_res) {
                    set_approve_data(approve_data_res);
                }
                set_contact_employee(contract_employees_res);
                set_files(file_conditions?.map((list) => {
                    return {
                        file: list
                    }
                }));
                set_cancel_reject_data((prev) => prev?.map((list, i) => {
                    return i == 0 ? {
                        ...list,
                        checked: response?.after_approves || false,
                        day: String(response?.after_approves_day || "0"),
                    } : i == 1 ? {
                        ...list,
                        checked: response?.before_booking || false,
                        day: String(response?.before_booking_day || "0"),
                    } : list
                }))
                // console.log(response, 'res');
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    useEffect(() => {
        handleGetDataDetail();
    }, [])

    useEffect(() => {
        handleGetEmployeeData();
    }, [handleGetEmployeeData])

    return (
        <ContainerLayout
            title=''
            hidden_sub_title
            content={
                <Box>
                    <Box>
                        <Typography variant='h6'>
                            {t("เงื่อนไขในการยกเลิกการจอง")}
                        </Typography>

                        <Box className="flex flex-col gap-4">
                            {cancel_reject_data?.map((list, i) => {
                                return (
                                    <Box className="grid grid-cols-12 gap-4" key={i + 1}>
                                        <span className='col-span-12 xl:col-span-2'>
                                            <CheckBoxCustom
                                                disabled={view}
                                                checked={list.checked}
                                                label={t(list.label)}
                                                setChecked={(st) => {
                                                    handleChange('checked', st, i);
                                                    if (!st) {
                                                        handleChange('day', "", i);
                                                    }
                                                }}
                                            />
                                        </span>
                                        <span className='col-span-12 xl:col-span-1'>
                                            <InputTextMask
                                                mode='full_number'
                                                value={list.day}
                                                onChange={(e) => handleChange('day', e.target.value, i)}
                                                disabled={!list.checked || view}
                                            />
                                        </span>
                                        <span className='col-span-12 xl:col-span-2'>
                                            {t("วัน")}
                                        </span>
                                    </Box>
                                )
                            })}
                        </Box>


                        <Box className='w-full mt-4 px-4 md:px-10'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={contact_employee?.length}
                                rowsData={contact_employee?.slice(
                                    (page - 1) * pageLimit,
                                    ((page - 1) * pageLimit) + pageLimit
                                ).map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </Box>

                        <Box>
                            <Box className="flex justify-start items-center gap-5">
                                <Typography>
                                    {t("ไฟล์หลักฐานการจองหรือข้อมูลที่เกี่ยวข้อง")}
                                </Typography>
                                {!view && (
                                    <Button onClick={handleAddFile} startIcon={<AddCircleOutlineOutlinedIcon />} color='success'>
                                        {t("เพิ่ม")}
                                    </Button>
                                )}
                            </Box>
                            <Box className="w-full flex flex-col gap-4">
                                {files?.map((list, i) => {
                                    return (
                                        <UploadFile
                                            onDrop={(nf) => {
                                                handleChangeFile(i, nf)
                                            }}
                                            fileAttachmentId={list?.file?.id_meeting_room_file || undefined}
                                            fileAttachmentName={list.file?.file_name || undefined}
                                            onDeleteFileId={view ? undefined : () => {
                                                handleDeleteFile(i);
                                            }}
                                            onDownloadFile={() => {
                                                list?.file?.id_meeting_room_file && handleDownloadFile(list?.file?.id_meeting_room_file, list.file?.file_name)
                                            }}
                                            customHeading={
                                                i !== 0 && !view &&
                                                <Button onClick={() => handleDeleteRow(i)} startIcon={<ClearOutlinedIcon />} sx={{ my: 1 }} variant='outlined' color='error'>
                                                    {t("ลบแถว")}
                                                </Button>
                                            }
                                            noClick={!!list?.file?.id_meeting_room_file || view}
                                            file={list?.file || null}
                                            onlyPdf
                                            onDeleteFile={() => {
                                                handleDeleteFile(i);
                                            }}
                                        />
                                    )
                                })}
                            </Box>
                        </Box>
                    </Box>


                    {show_modal && (
                        <ModalCustom
                            handleClose={handleCloseModal}
                            onClick={handleAddEmployee}
                            open
                            title={is_view ? t("รายละเอียดข้อมูลติดต่อผู้ดูแลห้อง") : t("เพิ่มข้อมูลติดต่อผู้ดูแลห้อง")}
                            scrollBody
                            hintSubmitButton={view || is_view}
                            subTitle={t("กรุณาเลือกรายการที่ท่านต้องการ")}
                            disabledSubmitButton={!employee_detail?.id_employee}
                            form={
                                <Box my={2} className="w-full flex flex-col gap-5">
                                    <StateComponents
                                        disabledAllField={view || is_view}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "AUTO-COMPLETE",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    getOptionLabel: (op) => op?.full_name || "",
                                                    labelId: "s",
                                                    placeholder: t("ระบุ"),
                                                    onChange: (_, val) => set_employee_detail(val ? {
                                                        contact_last_name: val?.last_name || "",
                                                        contact_name: val?.first_name || "",
                                                        department: val?.department_name || "",
                                                        email: val?.email_organization || "",
                                                        id_employee: val?.id_employee || null,
                                                        id_meeting_room_contact: null,
                                                        position: val?.position_name || "",
                                                        tel: val?.phone_number || "",
                                                        title: val?.title || "",
                                                        file_path: val?.file_path,

                                                    } : null),
                                                    onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_employyee }),
                                                    options: employee_data || [],
                                                    heading: t("ชื่อ-นามสกุล หรือ เลขประจำตัวเจ้าหน้าที่"),
                                                    value: employee_data?.find((x) => x?.id_employee == employee_detail?.id_employee) || null
                                                }
                                            },
                                        ]}
                                    />
                                    <div className='flex justify-center items-center w-full'>
                                        <ProfileCard
                                            data={{
                                                description: "",
                                                first_name: "",
                                                img_src: employee_detail?.file_path ? `${base_url_image}${employee_detail?.file_path}` : ImageContent.noImage,
                                                last_name: "",
                                                img_alt: "daw"
                                            }}
                                        />
                                    </div>

                                    <StateComponents
                                        disabledAllField
                                        otherProps={{ spacing: 2 }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    heading: t("ชื่อ-นามสกุล"),
                                                    value: `${employee_detail?.contact_name || ""} ${employee_detail?.contact_last_name || ""}`
                                                }
                                            },
                                            {
                                                seq: 2,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    heading: t("ตำแหน่งงานปัจจุบัน"),
                                                    value: employee_detail?.position || ""
                                                }
                                            },
                                            {
                                                seq: 3,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    heading: t("เบอร์โทร"),
                                                    value: employee_detail?.tel || ""
                                                }
                                            },
                                            {
                                                seq: 4,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    heading: t("อีเมลองค์กร"),
                                                    value: employee_detail?.email || ""
                                                }
                                            },
                                        ]}
                                    />
                                </Box>
                            }
                        />
                    )}


                    {!view && (
                        <Box my={2} className="flex justify-center items-center gap-4">
                            <Button onClick={() => navigate(routeName.cms.BookingRoomRequestMangement)} variant='outlined'>{t("ยกเลิก")}</Button>
                            <Button onClick={() => handleSubmitForm()} color='success' variant='contained'>{t("ยืนยัน")}</Button>
                        </Box>
                    )}
                    {show_cancel_booking && (
                        <Box my={2} className="flex justify-center items-center gap-4">
                            <Button onClick={() => navigate(routeName.cms.BookingRoomRequestMangement)} variant='outlined'>{t("ย้อนกลับ")}</Button>
                            <Button onClick={() => handleCancelBooking()} color='error' variant='contained'>{t("ยกเลิกการจอง")}</Button>
                        </Box>
                    )}
                </Box>
            }
        />
    )
}

export default MeetingRoomContact